const hash = (str) => {
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) h = Math.imul(h ^ str.charCodeAt(i), 16777619);
  return h >>> 0;
};

// Deterministic alien rune generated from the spore word.
export const SporeGlyph = ({ word = "", size = 120, className = "", testId }) => {
  let seed = hash(word || "spore");
  const rand = () => {
    seed = Math.imul(seed ^ (seed >>> 15), 2246822507) >>> 0;
    return (seed % 1000) / 1000;
  };
  const nodes = Array.from({ length: 7 }, (_, i) => {
    const a = (i / 7) * Math.PI * 2 + rand();
    const r = 18 + rand() * 26;
    return [50 + Math.cos(a) * r, 50 + Math.sin(a) * r];
  });
  const paths = nodes.map(([x, y], i) => {
    const [nx, ny] = nodes[(i + 1 + Math.floor(rand() * 3)) % nodes.length];
    const cx = 50 + (rand() - 0.5) * 30;
    const cy = 50 + (rand() - 0.5) * 30;
    return `M${x.toFixed(1)} ${y.toFixed(1)} Q${cx.toFixed(1)} ${cy.toFixed(1)} ${nx.toFixed(1)} ${ny.toFixed(1)}`;
  });

  return (
    <svg data-testid={testId} viewBox="0 0 100 100" width={size} height={size} className={className} aria-hidden="true">
      <circle cx="50" cy="50" r="46" fill="none" stroke="currentColor" strokeOpacity="0.25" strokeDasharray="2 4" />
      {paths.map((d, i) => (
        <path key={i} d={d} fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
      ))}
      {nodes.map(([x, y], i) => (
        <circle key={i} cx={x} cy={y} r={i % 3 === 0 ? 3.4 : 2} fill="currentColor" />
      ))}
      <circle cx="50" cy="50" r="4" fill="currentColor" />
    </svg>
  );
};
